module.exports = __webpack_public_path__ + "static/circle-7175bb7fdb85150bf07db7f8863daa4d.png";